export const Bohui =()=> <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 10C2 7.79 3.51 6 5.37 6H11.15L8.57 8.59L10 10L15 5L10 0L8.57 1.41L11.15 4H5.37C2.41 4 0 6.69 0 10C0 13.31 2.41 16 5.37 16H13V14H5.37C3.51 14 2 12.21 2 10Z" fill="#1F1F1F" />
</svg>
